// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4e2cce0","455":"0615052e","488":"97d9c563"}[chunkId] + ".chunk.js";
};